import React, { useState } from "react";
import {
  makeStyles,
  createStyles,
  Theme,
  withStyles,
  Button,
  Grid,
} from "@material-ui/core";

import { useSubMenuPostionState } from "../../../../contexts/MenuContext";
import IntroCompanyCss from "./IntroCompanyCss";
import ArchiveMenu from "./ArchiveMenu";
import ActiveMenu from "./ActiveMenu";
import LarborArtMenu from "./LarborArtMenu";

const useStyles = makeStyles((theme: Theme) => createStyles({}));

function MenuSection(topState: any) {
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const [inMenu, setInMenu] = useState<null | Boolean>(false);
  // const subMenuPosition = useSubMenuPostionState();
  // let scrollValue = topState.topState.topState;
  // let judege = topState.topState.judege;

  const classes = useStyles();
  return (
    <Grid
      xs={12}
      item
      container
      // onMouseEnter={() => {
      //   setInMenu(true);
      // }}
      // onMouseLeave={() => {
      //   setInMenu(false);
      // }}
    >
      <IntroCompanyCss
        link={"/about"}
        menuName={"노동인권문화제 소개"}
        // scrollValue={scrollValue}
        // judege={judege}
      />
      <ActiveMenu
        // link={"/active"}
        menuName={"활동"}
        // scrollValue={scrollValue}
        // judege={judege}
      />
      <LarborArtMenu
        menuName={"노동 X 예술"}
        // scrollValue={scrollValue}
        // judege={judege}
      />
      <ArchiveMenu
        link={"/archive"}
        menuName={"아카이브"}
        // scrollValue={scrollValue}
        // judege={judege}
      />
    </Grid>
  );
}

export default MenuSection;
